import {
  GET_ASSOCIATED_CONTACTS_REQUESTED,
  GET_ASSOCIATED_CONTACTS_SUCCESS,
  GET_ASSOCIATED_CONTACTS_FAILURE,
} from './associatedContacts.constants'

const initialState = {
  error: false,
  loading: true,
  data: [],
}

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_ASSOCIATED_CONTACTS_REQUESTED:
      return {
        ...state,
        error: false,
        loading: true,
        data: [],
      }

    case GET_ASSOCIATED_CONTACTS_SUCCESS:
      return {
        ...state,
        error: false,
        loading: false,
        data: action.data,
      }

    case GET_ASSOCIATED_CONTACTS_FAILURE:
      return {
        ...state,
        error: action.error.message,
        loading: false,
        data: [],
      }

    default:
      return state
  }
}
